import { useState, useRef, useEffect, type CSSProperties } from "react";
import { useAuth } from "../../../lib/hooks/use-auth";

export function UserMenu() {
  const { user, logout, currentWorkspaceId } = useAuth();
  const [open, setOpen] = useState(false);
  const ref = useRef<HTMLDivElement>(null);

  useEffect(() => {
    function onDown(e: MouseEvent) {
      if (ref.current && !ref.current.contains(e.target as Node)) setOpen(false);
    }
    document.addEventListener("mousedown", onDown);
    return () => document.removeEventListener("mousedown", onDown);
  }, []);

  const initials = user?.name
    ? user.name.split(/\s+/).map((w) => w[0]).join("").slice(0, 2).toUpperCase()
    : "?";

  const avatarStyle: CSSProperties = {
    width: 28,
    height: 28,
    borderRadius: "50%",
    background: "var(--c-gray-600)",
    color: "#fff",
    display: "inline-flex",
    alignItems: "center",
    justifyContent: "center",
    fontSize: 11,
    fontWeight: 500,
    cursor: "pointer",
    border: "none",
    padding: 0,
  };

  const dropdownStyle: CSSProperties = {
    position: "absolute",
    top: "calc(100% + 4px)",
    right: 0,
    minWidth: 200,
    background: "var(--color-background-primary)",
    border: "var(--kuvio-border-default)",
    borderRadius: "var(--border-radius-md)",
    padding: 4,
    zIndex: 50,
    fontFamily: "var(--font-sans)",
  };

  const itemStyle: CSSProperties = {
    display: "block",
    width: "100%",
    padding: "8px 10px",
    border: "none",
    background: "transparent",
    fontSize: 13,
    textAlign: "left",
    borderRadius: "var(--border-radius-sm)",
    color: "var(--color-text-primary)",
    cursor: "pointer",
  };

  const labelStyle: CSSProperties = {
    ...itemStyle,
    color: "var(--color-text-tertiary)",
    fontSize: 11,
    cursor: "default",
  };

  return (
    <div ref={ref} style={{ position: "relative" }}>
      <button style={avatarStyle} onClick={() => setOpen((v) => !v)} aria-label="User menu">
        {initials}
      </button>
      {open && (
        <div style={dropdownStyle}>
          {currentWorkspaceId && (
            <div style={labelStyle}>Workspace</div>
          )}
          {user?.email && (
            <div style={{ ...labelStyle, marginBottom: 4 }}>{user.email}</div>
          )}
          <button
            style={itemStyle}
            onClick={() => { setOpen(false); logout(); }}
          >
            Sign out
          </button>
        </div>
      )}
    </div>
  );
}
